module.exports = __webpack_public_path__ + "img/sr.ca454926.svg";